// GENERATED by tools/build_score_ts.py from the transcription in
// nsm-sight-reading/scores/src/twinkle-melody.json — do not edit here.
// Every note carries an absolute start and duration in quarter notes, so
// the engraving and the playback clock cannot disagree about timing.
import type { Score } from "@/courses/sight-reading/types";

export const twinkleMelody: Score = {
  slug: "twinkle-melody",
  n: 2,
  title: "Twinkle Twinkle \u2014 Melody",
  composer: "Mozart",
  rights: "public-domain",
  publicSafe: true,
  key: "C",
  fifths: 0,
  time: [4, 4],
  tempo: 100,
  staves: 1,
  clefs: ["treble"],
  bars: 13,
  barQuarters: 4.0,
  lowest: 60,
  highest: 69,
  hasLyrics: true,
  jasonNote: "\"Twinkle, Twinkle, Little Star\" is a popular English lullaby and the great Mozart wrote the music for it long, long ago. Notice how every 2 bars have the same rhythm. Try clapping them and get used to them. As you learn up your scales, try playing this melody on various key signatures.",
  teaches: [
    "two-bar rhythmic repetition",
    "transposing the same melody into other keys",
    "singing while playing"
  ],
  art: "/sight-reading/art/twinkle-melody.jpg",
  artRights: "stock",
  background: "/sight-reading/bg/twinkle-melody.jpg",
  notes: [
    { bar: 1, hand: "rh", start: 0.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", lyric: "Twin" },
    { bar: 1, hand: "rh", start: 1.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", lyric: "kle" },
    { bar: 1, hand: "rh", start: 2.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter", lyric: "Twin" },
    { bar: 1, hand: "rh", start: 3.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter", lyric: "kle" },
    { bar: 2, hand: "rh", start: 4.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter", lyric: "Li" },
    { bar: 2, hand: "rh", start: 5.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter", lyric: "ttle" },
    { bar: 2, hand: "rh", start: 6.0, dur: 2.0, midi: 67, pitch: "G4", d: "half", lyric: "star" },
    { bar: 3, hand: "rh", start: 8.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter", lyric: "How" },
    { bar: 3, hand: "rh", start: 9.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter", lyric: "I" },
    { bar: 3, hand: "rh", start: 10.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter", lyric: "won" },
    { bar: 3, hand: "rh", start: 11.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter", lyric: "der" },
    {
  bar: 4,
  hand: "rh",
  start: 12.0,
  dur: 1.0,
  midi: 62,
  pitch: "D4",
  d: "quarter",
  lyric: "what"
},
    { bar: 4, hand: "rh", start: 13.0, dur: 1.0, midi: 62, pitch: "D4", d: "quarter", lyric: "you" },
    { bar: 4, hand: "rh", start: 14.0, dur: 2.0, midi: 60, pitch: "C4", d: "half", lyric: "are" },
    { bar: 5, hand: "rh", start: 16.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter", lyric: "up" },
    { bar: 5, hand: "rh", start: 17.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter", lyric: "A" },
    {
  bar: 5,
  hand: "rh",
  start: 18.0,
  dur: 1.0,
  midi: 65,
  pitch: "F4",
  d: "quarter",
  lyric: "bove"
},
    { bar: 5, hand: "rh", start: 19.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter", lyric: "the" },
    {
  bar: 6,
  hand: "rh",
  start: 20.0,
  dur: 1.0,
  midi: 64,
  pitch: "E4",
  d: "quarter",
  lyric: "world"
},
    { bar: 6, hand: "rh", start: 21.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter", lyric: "so" },
    { bar: 6, hand: "rh", start: 22.0, dur: 2.0, midi: 62, pitch: "D4", d: "half", lyric: "high" },
    {
  bar: 7,
  hand: "rh",
  start: 24.0,
  dur: 1.0,
  midi: 67,
  pitch: "G4",
  d: "quarter",
  lyric: "like"
},
    { bar: 7, hand: "rh", start: 25.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter", lyric: "a" },
    { bar: 7, hand: "rh", start: 26.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter", lyric: "dia" },
    {
  bar: 7,
  hand: "rh",
  start: 27.0,
  dur: 1.0,
  midi: 65,
  pitch: "F4",
  d: "quarter",
  lyric: "mond"
},
    { bar: 8, hand: "rh", start: 28.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter", lyric: "in" },
    { bar: 8, hand: "rh", start: 29.0, dur: 1.0, midi: 64, pitch: "E4", d: "quarter", lyric: "the" },
    { bar: 8, hand: "rh", start: 30.0, dur: 2.0, midi: 62, pitch: "D4", d: "half", lyric: "sky" },
    {
  bar: 9,
  hand: "rh",
  start: 32.0,
  dur: 1.0,
  midi: 60,
  pitch: "C4",
  d: "quarter",
  lyric: "Twin"
},
    { bar: 9, hand: "rh", start: 33.0, dur: 1.0, midi: 60, pitch: "C4", d: "quarter", lyric: "kle" },
    {
  bar: 9,
  hand: "rh",
  start: 34.0,
  dur: 1.0,
  midi: 67,
  pitch: "G4",
  d: "quarter",
  lyric: "Twin"
},
    { bar: 9, hand: "rh", start: 35.0, dur: 1.0, midi: 67, pitch: "G4", d: "quarter", lyric: "kle" },
    { bar: 10, hand: "rh", start: 36.0, dur: 1.0, midi: 69, pitch: "A4", d: "quarter", lyric: "Li" },
    {
  bar: 10,
  hand: "rh",
  start: 37.0,
  dur: 1.0,
  midi: 69,
  pitch: "A4",
  d: "quarter",
  lyric: "ttle"
},
    { bar: 10, hand: "rh", start: 38.0, dur: 2.0, midi: 67, pitch: "G4", d: "half", lyric: "star" },
    {
  bar: 11,
  hand: "rh",
  start: 40.0,
  dur: 1.0,
  midi: 65,
  pitch: "F4",
  d: "quarter",
  lyric: "How"
},
    { bar: 11, hand: "rh", start: 41.0, dur: 1.0, midi: 65, pitch: "F4", d: "quarter", lyric: "I" },
    {
  bar: 11,
  hand: "rh",
  start: 42.0,
  dur: 1.0,
  midi: 64,
  pitch: "E4",
  d: "quarter",
  lyric: "won"
},
    {
  bar: 11,
  hand: "rh",
  start: 43.0,
  dur: 1.0,
  midi: 64,
  pitch: "E4",
  d: "quarter",
  lyric: "der"
},
    {
  bar: 12,
  hand: "rh",
  start: 44.0,
  dur: 1.0,
  midi: 62,
  pitch: "D4",
  d: "quarter",
  lyric: "what"
},
    {
  bar: 12,
  hand: "rh",
  start: 45.0,
  dur: 1.0,
  midi: 62,
  pitch: "D4",
  d: "quarter",
  lyric: "you"
},
    {
  bar: 12,
  hand: "rh",
  start: 46.0,
  dur: 2.0,
  midi: 60,
  pitch: "C4",
  d: "half",
  tie: "start",
  lyric: "are"
},
    { bar: 13, hand: "rh", start: 48.0, dur: 4.0, midi: 60, pitch: "C4", d: "whole", tie: "stop" },
  ],
};
